module.exports = __webpack_public_path__ + "img/delta_to_star_trafo 2.5fa13256.svg";